import styled from 'styled-components'

export const FormWrapper = styled.div`
  padding: 20px;
  
  .ant-form {
    max-width: 600px;
    margin: 0 auto;
  }
  
  .ant-form-item-label {
    label {
      font-weight: 500;
      color: #262626;
    }
  }
  
  .ant-divider {
    margin: 16px 0;
  }
`

export const CampaignHeader = styled.div`
  text-align: center;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid #f0f0f0;
  
  .campaign-name {
    font-size: 18px;
    font-weight: 600;
    color: #262626;
    margin: 0;
  }
  
  .campaign-label {
    font-size: 12px;
    color: #8c8c8c;
    margin-bottom: 4px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
`

export const FormSection = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-bottom: 16px;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`

export const ReadOnlyField = styled.div`
  padding: 8px 12px;
  background: #f5f5f5;
  border-radius: 4px;
  
  .label {
    display: block;
    font-size: 12px;
    color: #8c8c8c;
    margin-bottom: 4px;
    font-weight: 500;
  }
  
  .value {
    font-size: 14px;
    color: #262626;
    font-weight: 500;
  }
`

export const FormActions = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
`